import React, { useContext } from "react";
import { QuestionSection, RadioRange } from "../../components/utility/quote";
import { navigate } from "gatsby-link";

import HardwareContext from "../../contexts/hardwareContext";
import RadioCircle from "../../svgs/radioCircle";

const Next = "/hardware/Questions/3";
const Points = [
  {
    question: "How many users on the network?",
    progress: "50%",
    options: [
      {
        answer: "1-4",
        to: Next,
        icon: <RadioCircle />,
      },
      { answer: "5-9", to: Next, icon: <RadioCircle /> },
      { answer: "10-24", to: Next, icon: <RadioCircle /> },
      { answer: "25-49", to: Next, icon: <RadioCircle /> },
      { answer: "50+", to: Next, icon: <RadioCircle /> },
    ],
  },
];
export default function Question2({ title }) {
  const { que2, setQue2 } = useContext(HardwareContext);

  return Points.map((item) => {
    return (
      <QuestionSection
        title={title}
        question={item.question}
        progress={item.progress}
      >
        {item.options.map((items) => {
          return (
            <RadioRange
              key={items.answer}
              icon={items.icon}
              value={items.answer}
              title={items.answer}
              isSelected={que2 === items.answer}
              onChange={(e) => {
                setQue2(e.target.value);
                navigate(items.to);
              }}
            />
          );
        })}
      </QuestionSection>
    );
  });
}
